import { useDispatch } from "react-redux"
import { useModalState, ModalActions } from "web/redux/slices/modal-slice"
import React from "react"
import { EditSegmentModal } from "./EditSegmentModal"
import { ConfirmModal } from "./ConfirmModal"
import { EditEventModal } from "./EditEventModal"
import { TextAreaModal } from "./TextAreaModal"
import { InfoModal } from "./InfoModal"
import { EditPlayerModal } from "./EditPlayerModal"
import { NewPatchInfoModal } from './NewPatchInfoModal'
import { ImportFightModal } from './ImportFightModal'
import { PromptModal } from './PromptModal'
import { TabbedExportModal } from './tabbed-export-modal/TabbedExportModal'
import { CreateOutlineModal } from './CreateOutlineModal'
import { PruneOutlinesModal } from './PruneOutlinesModal'
import { SetupGistModal } from './SetupGistModal'

export type ModalContainerProps = {
    closeSelf: () => void
}

/**
 * Base modal component, takes care of mounting all other modals from state
 */
export const ModalContainer: React.FC = () => {

    const disp = useDispatch()
    const [modalState] = useModalState()

    const openModals = modalState.modals.map(openModal => {
        const closeSelf = () => {
            disp(ModalActions.closeModal({ modalId: openModal.id }))
        }

        if (openModal.type === "setup-gist") {
            return (
                <SetupGistModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "prune-outlines") {
            return (
                <PruneOutlinesModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "create-outline") {
            return (
                <CreateOutlineModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "prompt") {
            return (
                <PromptModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "tabbed-export") {
            return (
                <TabbedExportModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "import-fight") {
            return (
                <ImportFightModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "edit-segment") {
            return (
                <EditSegmentModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "edit-event") {
            return (
                <EditEventModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "edit-player") {
            return (
                <EditPlayerModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "text-area") {
            return (
                <TextAreaModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "info") {
            return (
                <InfoModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "confirm") {
            return (
                <ConfirmModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        if (openModal.type === "new-patch-info") {
            return (
                <NewPatchInfoModal
                    key={openModal.id}
                    closeSelf={closeSelf}
                    {...openModal.options}
                />
            )
        }

        throw Error(`Unknown modal type: ${openModal.type}`)
    })

    return (
        <>
            {openModals}
        </>
    )
}
